<template>
    <div v-if="personalSettings">
        <span class="tag is-light" v-if="weekSum < personalSettings.workWeekTime || !weekSum">
            <span v-if="displayText">{{ displayText }}&nbsp;</span>
            <span v-else class="icon"> 
                <font-awesome-icon :icon="['fas', 'clock']"></font-awesome-icon>
            </span>
            {{ weekSum }}
            <span v-if="personalSettings.workWeekTime > 0">&nbsp;/ {{ personalSettings.workWeekTime }}</span>
        </span>
        <span class="tag is-success" v-if="(weekSum >= personalSettings.workWeekTime) && weekSum > 0">
            <span v-if="displayText">{{ displayText }}&nbsp;</span>
            <span v-else class="icon"> 
                <font-awesome-icon :icon="['fas', 'clock']"></font-awesome-icon>
            </span>
            {{ weekSum }}
            <span v-if="personalSettings.workWeekTime > 0">&nbsp;/ {{ personalSettings.workWeekTime }}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'weekTimeSum',
    props: {
        allRegistrations: Array,
        weekNo: Number,
        personalSettings: Object,
        displayText: String,
    },
    computed: {
        weekSum() {
            const self = this;
            const sum = _.sumBy(_.filter(this.allRegistrations, function(o) {
                if(moment(o.date).isoWeek() ===  Number(self.weekNo)) {return o}
            }), 'time');
            if (sum > 0) {
                return sum;
            } else {
                return 0;
            }
        },
    }

}
</script>

<style>

</style>
